import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useTheme } from 'styled-components';

var legacySwappable = function legacySwappable(LegacyComponent, DefaultComponent) {
  return React.forwardRef(function (props, ref) {
    var theme = useTheme();
    return theme.name === 'legacy' ? /*#__PURE__*/React.createElement(LegacyComponent, _extends({}, props, {
      ref: ref
    })) : /*#__PURE__*/React.createElement(DefaultComponent, _extends({}, props, {
      ref: ref
    }));
  });
};

export default legacySwappable;